export default function ContactSection() {
  return (
    <section id="contact" className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">联系我们</h2>
            <p className="text-sm text-foreground-600">有想推荐的睡前电影？欢迎投稿分享你的深夜片单</p>
          </div>
          <div className="bg-background-100 rounded-2xl p-8 md:p-10">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
              <div className="flex flex-col items-center gap-2">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-mail-line text-xl"></i>
                </span>
                <h3 className="text-sm font-medium text-foreground-950">投稿邮箱</h3>
                <p className="text-sm text-foreground-600">hello@springnightcinema.com</p>
              </div>
              <div className="flex flex-col items-center gap-2">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                  <i className="ri-wechat-line text-xl"></i>
                </span>
                <h3 className="text-sm font-medium text-foreground-950">微信公众号</h3>
                <p className="text-sm text-foreground-600">春夜影院</p>
              </div>
              <div className="flex flex-col items-center gap-2">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-message-3-line text-xl"></i>
                </span>
                <h3 className="text-sm font-medium text-foreground-950">反馈建议</h3>
                <p className="text-sm text-foreground-600">随时私信，24h 内回复</p>
              </div>
            </div>
            <div className="mt-8 pt-8 border-t border-background-200/70">
              <p className="text-center text-sm text-foreground-600 leading-relaxed">
                我们期待听到你的声音。无论是推荐一部冷门好片、分享你的深夜观影故事，还是对平台提出建议，都欢迎随时联系我们。每一个春夜都值得被温柔对待，每一部好电影都值得被更多人看见。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}